var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Key = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 960 960.18", width: "1em", height: "1em" }, props),
    React.createElement("path", { d: "M888.14 72a245.35 245.35 0 0 0-417.31 146.3 246.43 246.43 0 0 0 34.83 155.73 31.91 31.91 0 0 1-4.27 39.47l-492 492a32 32 0 0 0 45.26 45.25L96 909.44l41.37 41.37a32 32 0 1 0 45.26-45.25l-41.38-41.38L160 845.44l41.37 41.37a32 32 0 1 0 45.26-45.25l-41.38-41.38L224 781.44l41.37 41.37a32 32 0 1 0 45.26-45.25l-41.38-41.38L546.64 458.8c31.47-31.47 37-80.12 13.5-118.3a182.17 182.17 0 0 1-25.7-115.1 181.18 181.18 0 0 1 308.45-108.1c70.7 70.7 70.7 185.74 0 256.44a181.07 181.07 0 0 1-164.52 49.46 32 32 0 1 0-12.74 62.72A245.17 245.17 0 0 0 888.14 419a245.32 245.32 0 0 0 0-346.95z", fill: "currentColor", "data-name": "Layer 2" }))); };
export default Key;
//# sourceMappingURL=Key.js.map